export default __webpack_public_path__ + "static/media/LinearPrice.b1bf2864.svg";